<template lang="pug">
  .supporters
    .head.row.ac.col-s
      h1 FUNCIONÁRIOS
      Button(:layout="showForm ? 'red-go' : 'green-go'" title="NOVO FUNCIONÁRIO" @click="showForm = !showForm" style="margin-left: 10px") {{ showForm ? "x" : "+" }}
      .new.g-11(v-if="showForm")
        FuncionarioForm(:cb="()=>(load(),showForm=false)")
    .filters.row.wp
      .g2.g12-s
        label Nome
        input(@keyup.enter="load()" class="input" v-model="filter.nome" placeholder="Nome")
      .g2.g12-s
        label Status
        select.input(v-model="filter.status")
          option(value="") SELECIONE
          option(value="ativo") Ativo
          option(value="inativo") Inativo
      .g1.g12-s.row.ae
        Button(layout="green-go g12-s" @click="load" :loader="loader")
          i.fa.fa-search 
          | LISTAR  
    .list(v-if="list.length > 0 || loader")
      .col.ac.jc(v-if="loader")
        Loader(layout="small")
      .container(v-else)
          .head.row.js
            .g1 ID
            .g2 Nome
            .g3 E-mail
            .g2 Celular
            .g2 Status
          .content
            div(v-for="(item, i) of list" :key="'item' + i")
              .line.row.js.ac(@click.stop="toggle(i)")
                .g1 {{ item.id }}
                .g2 {{ item.nome }}
                .g3 {{ item.email }}
                .g2 {{ item.celular | phone }}
                .g2(:class="item.status=='inativo' && 'text-red'") {{ item.status }}
               
              .edit.row.wp.col-s(v-if="item.show")
                FuncionarioForm(v-if="item.info" :f="item.info" :cb="load")
                Loader(layout="small" v-else)
    Modal(:modal="modal")
      .historic(v-if="modal.mod == 'historic'")
        .title.row
          .g1 ID
          .g8 Histórico
          .g3 Criado
        .line.row.ac(v-for="item of historic.list" :key="item.id")
          .g1 {{ item.id }}
          .g8 {{ item.historico }}
          .g3(style="min-width: 160px")
            b {{ item.criado_em | date }}
            | por {{ item.nome_criado_por }}
      .files(v-if="modal.mod == 'files'")
        .title.row
          .g3 Enviado
          .g6 Arquivo
          .g3 Data Validação
        .line.row.ac(v-for="item of files.list" :key="item.criado_em")
          .g3 {{ item.criado_em | date }}
          .g6 
            a(:href="`/portal/arquivo/${item.id}/doutor/${item.id_doutor}`" target="_blank") {{ item.descricao }}
          .g3 {{ item.dh_validacao | date }}
</template>

<script>

import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";
import Modal from "@/components/Modal.vue";
import estados from '../../../public/json/cidades.json'
import FuncionarioForm from "@/views/admin/components/FuncionarioForm.vue";

export default {
  name: "Supporters",
  components: {
    Button,
    FuncionarioForm,
    Loader,
    Modal
  },
  data() {
    return {
      estados: estados,
      filter: { nome: "", status: "" },
      loader: false,
      showForm: false,
      historic: {
        mod: 'historic',
        title: "Histórico Supporter",
        show: true,
        callback: () => this.historic.show = true,
        list: []
      },
      modal: {},
      list: [],
      search: "",

    };
  },
  methods: {
    ...mapActions("admin", ["FUNCIONARIO_LIST", "FUNCIONARIO_GET"]),
    async load() {
      this.loader = true;
      //let filter = this.filter.length ? { [this.filter]: this.search } : {}
      await this.FUNCIONARIO_LIST(this.filter).then(({ data }) => this.list = data || [])
      this.loader = false
    },
    async toggle(index) {
      this.list[index].show = !this.list[index].show;

      if (this.list[index].show) {
        await this.FUNCIONARIO_GET(this.list[index].id).then(({ data }) => {
          data.dt_nascimento = data.dt_nascimento.split('-').reverse()
          this.list[index].info = data || {};
          this.list[index].info.update = true;
          this.list[index].info.send = (form) => this.update(form);
          this.list[index].info.updateStatus = (form) => this.update_status(form);
          this.list[index].info.del = (form) => this.del(form);
          this.list = [...this.list];
        });
      } else this.list = [...this.list];
    },

  },
  mounted() {
    this.$parent.$children[0].changeMenu("funcionarios");
  }
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.supporters
  @include page
  .filters
    margin-top: 10px
    button
      margin-left:0px
      @media (max-width: $small)
        margin-top: 20px
    .input, select
      @media (max-width: $small)
        width: 94%
        margin-top: 24px
        margin-left: 8px
      @media (min-width: $small)
        width: 90%
  .list
    overflow: auto
    font-size: 15px
    @media (max-width: $small)
      margin: 23px 6px
    .container
      min-width: 1200px
    .controls
      color: $purple
      font-size: 19px
      .icons
        font-size: 11px
        border-radius: 4px
        padding: 6px
        margin-right: 4px
        &:hover
          background: white
          color: $purple
        i
          margin-right: 3px
          font-size: 12px
        
    .line:hover
      .controls
        color: white
  .historic
    max-height: 400px
</style>